import { Grid } from "@material-ui/core";
import { useFormik } from "formik";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import GoogleReCaptcha from "../../../components/GoogleReCaptcha";
import RxAutoComplete from "../../../components/RxAutoComplete";
import RxBox from "../../../components/RxBox";
import RxCheckBox from "../../../components/RxCheckBox";
import RxMaskedTextField from "../../../components/RxMaskedTextField";
import { RxSelectBoxItemObject } from "../../../components/RxSelectBox/RxSelectBox";
import RxTextField from "../../../components/RxTextField";
import { RegisterObject, RegisterObjectInitialValue } from "../RegisterObject";
import { UserStepFormValidationObject } from "../RegisterPage";
import styles from "./UserInfoStepStyle.module.css";
import UserInfoStepValidation from "./UserInfoStepValidation";

interface LoginInfoStepProps {
	setValidataResult?: any;
	values?: RegisterObject;
	constantDataList: {
		provinces: RxSelectBoxItemObject[];
		companyTypes: RxSelectBoxItemObject[];
		jobTypes: RxSelectBoxItemObject[];
	};
	setGoogleReCaptchaToken: (token: string) => void;
}

const UserInfoStep = (props: LoginInfoStepProps) => {
	const recaptchaSiteKey = useSelector(
		(state: any) => state.recaptcha.siteKey
	);

	const formik = useFormik({
		initialValues: props.values ?? RegisterObjectInitialValue,
		validationSchema: UserInfoStepValidation,
		validateOnBlur: true,
		validateOnChange: true,
		onSubmit: () => {
			// Form submit edilmediği için bulunuyor. (Sonar uyarısı için)
			console.log("No submit button for this form...");
		},
	});

	useEffect(() => {
		if (!formik.isValid) {
			props.setValidataResult &&
				props.setValidataResult(
					(
						prev: UserStepFormValidationObject
					): UserStepFormValidationObject => {
						return {
							...prev,
							isUserInfoStepValid: false,
						};
					}
				);
		} else {
			props.setValidataResult &&
				props.setValidataResult(
					(
						prev: UserStepFormValidationObject
					): UserStepFormValidationObject => {
						return {
							...prev,
							isUserInfoStepValid: true,
						};
					}
				);
		}
	}, [formik.isValid]); // eslint-disable-line

	useEffect(() => {
		props.setValidataResult &&
			props.setValidataResult(
				(
					prev: UserStepFormValidationObject
				): UserStepFormValidationObject => {
					return { ...prev, values: formik.values };
				}
			);
	}, [formik.values]); // eslint-disable-line

	useEffect(() => {
		formik.validateForm();
	}, []); // eslint-disable-line

	return (
		<form>
			<Grid container direction="row" spacing={2}>
				<Grid item xs={2} sm={2}></Grid>
				<Grid item xs={8} sm={8}>
					<Grid container spacing={1}>
						<Grid item xs={6} sm={6}>
							<RxTextField
								required
								fullwidth
								id="userInfo.name"
								name="userInfo.name"
								label="Adınız"
								placeholder="Adınız"
								value={formik.values.userInfo.name}
								onChange={formik.handleChange}
								onBlur={formik.handleBlur}
							/>
						</Grid>
						<Grid item xs={6} sm={6}>
							<RxTextField
								required
								fullwidth
								id="userInfo.surname"
								name="userInfo.surname"
								label="Soyadınız"
								placeholder="Soyadınız"
								value={formik.values.userInfo.surname}
								onChange={formik.handleChange}
								onBlur={formik.handleBlur}
							/>
						</Grid>
						<Grid item xs={6} sm={6}>
							<RxAutoComplete
								required
								name="job"
								inputLabel="Mesleğiniz"
								options={props.constantDataList.jobTypes}
								handleSelectChange={(e: any, newValue: any) => {
									formik.setFieldValue("userInfo.job", newValue.value);
								}}
							/>
						</Grid>
						<Grid item xs={6} sm={6}>
							<RxTextField
								fullwidth
								id="userInfo.title"
								name="userInfo.title"
								label="Ünvan"
								placeholder="Ünvan"
								value={formik.values.userInfo.title}
								onChange={formik.handleChange}
								onBlur={formik.handleBlur}
							/>
						</Grid>
						<Grid item xs={6} sm={6}>
							<RxMaskedTextField
								fullwidth
								required
								alwaysShowMask
								id="userInfo.phone"
								name="userInfo.phone"
								mask="0(999)-999-99-99"
								label="Telefon"
								placeholder="Telefon"
								value={formik.values.userInfo.phone}
								onChange={formik.handleChange}
							/>
						</Grid>
						<Grid item xs={6} sm={6}>
							<RxMaskedTextField
								fullwidth
								alwaysShowMask
								id="userInfo.gsm"
								name="userInfo.gsm"
								mask="0(599)-999-99-99"
								label="Cep Telefon"
								placeholder="Cep Telefon"
								value={formik.values.userInfo.gsm}
								onChange={formik.handleChange}
							/>
						</Grid>
						<Grid item xs={6} sm={6}>
							<RxAutoComplete
								required
								name="companyType"
								inputLabel="Kuruluş Türünüz"
								options={props.constantDataList.companyTypes}
								handleSelectChange={(e: any, newValue: any) => {
									formik.setFieldValue(
										"userInfo.companyType",
										newValue.value
									);
								}}
							/>
						</Grid>
						<Grid item xs={6} sm={6}>
							<RxTextField
								required
								fullwidth
								id="userInfo.companyName"
								name="userInfo.companyName"
								label="Kuruluş Adı"
								placeholder="Kuruluş Adınız"
								value={formik.values.userInfo.companyName}
								onChange={formik.handleChange}
								onBlur={formik.handleBlur}
							/>
						</Grid>
						<Grid item xs={6} sm={6}>
							<RxAutoComplete
								required
								name="province"
								inputLabel="İliniz"
								options={props.constantDataList.provinces}
								handleSelectChange={(e: any, newValue: any) => {
									formik.setFieldValue(
										"userInfo.province",
										newValue.value
									);
								}}
							/>
						</Grid>
						<Grid item xs={6} sm={6}>
							<RxTextField
								fullwidth
								id="userInfo.district"
								name="userInfo.district"
								label="İlçe"
								placeholder="İlçeniz"
								value={formik.values.userInfo.district}
								onChange={formik.handleChange}
								onBlur={formik.handleBlur}
							/>
						</Grid>
						<Grid item xs={12} sm={12}>
							<RxTextField
								fullwidth
								required
								id="userInfo.address"
								name="userInfo.address"
								label="Adres"
								placeholder="Adresiniz"
								onBlur={formik.handleBlur}
								onChange={formik.handleChange}
								value={formik.values.userInfo.address}
							/>
						</Grid>
					</Grid>
				</Grid>
				<Grid item xs={2} sm={2}></Grid>
				<Grid item xs={12} sm={12}>
					<Grid container spacing={1}>
						<Grid item xs={2} sm={2}></Grid>
						<Grid item xs={8} sm={8} className={styles.gridStyle}>
							<RxCheckBox
								checked={formik.values.userInfo.isAgreementApprove}
								onChange={formik.handleChange}
								outId="userInfo.isAgreementApprove"
								outName="userInfo.isAgreementApprove"
							/>
							<span className={styles.textStyle}>
								{" * "}
								<a
									href="#/membership"
									target="_blank"
									rel="noopener  noreferrer"
								>
									Üyelik ve Gizlilik Sözleşmesi
								</a>{" "}
								ve{" "}
								<a
									href="#/kvkk"
									target="_blank"
									rel="noopener  noreferrer"
								>
									Kişisel Verilerin Korunması Kanunu (KVKK) Aydınlatma
									Metni
								</a>
								'ni okudum, kabul ediyorum.
							</span>
						</Grid>
						<Grid item xs={2} sm={2}></Grid>
					</Grid>
					<Grid container spacing={1}>
						<Grid item xs={2} sm={2}></Grid>
						<Grid item xs={10} sm={10}>
							{!formik.isValid ? (
								<RxBox
									color="red"
									className={styles.gridStyle}
									label="* Bulunan alanların doldurulması zorunludur."
								/>
							) : (
								<br />
							)}
						</Grid>
					</Grid>
				</Grid>
				<GoogleReCaptcha
					siteKey={recaptchaSiteKey}
					setGoogleReCaptchaToken={props.setGoogleReCaptchaToken}
				/>
			</Grid>
		</form>
	);
};
export default UserInfoStep;
